import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';
import { OBJECT_DANGER_CLASS_NOT_EXTREMELY_HIGH_RISK } from '../../MainModule/constants/notices';
import { addNoticeAction } from '../actions/NoticeActions';

export const addNoticeObjectDangerClass = () =>
  addNoticeAction({
    renderContent: OBJECT_DANGER_CLASS_NOT_EXTREMELY_HIGH_RISK,
    noticeType: NoticeTypesEnum.ERROR,
    messageType: MessageTypesEnum.KNM_FILE_SIZE,
  });
